export const GET_USER = 'rental-manager-api/api/web/v2/users/get';
export const GET_APPLICATION_PERMISSIONS =
  'rental-manager-api/api/v1/users/applications/getApplicationPermissionsForListing';
export const GET_PROPERTY_DETAILS = 'rental-manager-api/api/v1/users/properties/details';
export const GET_GOOGLE_MAPS_SIGNED_URL = 'rental-manager-api/api/v1/multibrandSupport/googleMaps';
export const GET_LEGAL_COMPLIANCE = 'rental-manager-api/api/v1/users/screening/getLegalCompliance';
export const ACCEPT_LEGAL_COMPLIANCE_V2 = 'rental-manager-api/api/v2/users/screening/acceptLegalCompliance';
export const PROXY_PATH = 'rental-manager/applications/proxy/';

const FETCH_APPLICANTS_DATA_ENDPOINT = 'rental-manager-api/api/v1/users/capps/getApplicationSnapshots',
  FETCH_ID_VERIFICATION_STATUS_ENDPOINT = 'rental-manager-api/api/v1/users/idVerification/isIdentified',
  FETCH_LISTING_APPLICATIONS_ENDPOINT = 'rental-manager-api/api/v1/users/capps/getListingApplicationOverviews',
  FETCH_ONBOARDING_PAGE_VIEWED = 'rental-manager-api/api/v1/users/capps/isCappsUser',
  GET_APPLICATIONS_BROWNOUT_WARNING_MESSAGE_ENDPOINT =
    'rental-manager-api/api/v1/users/capps/getRentalApplicationsBrownoutWarningMessage',
  GET_LEAD_DETAILS = 'rental-manager-api/api/v1/users/leads/details',
  MARK_RENTAL_TERMS_ACCEPTED_ENDPOINT = 'rental-manager-api/api/v1/users/termsAndConditions/markAcceptedTerms',
  RETRIEVE_SHARED_DOCUMENTS = 'rental-manager-api/api/v1/users/rad/retrieveSharedDocumentsV2',
  SEND_INVITATION = 'rental-manager-api/api/v1/users/capps/handleApplicationInvitation',
  COPY_APPLICATION_LINK = 'rental-manager-api/api/v1/users/capps/handleApplicationInvitationLink',
  SET_ENROLLMENT_STATUS = 'rental-manager-api/api/v1/users/properties/applicationsAccepted',
  UPDATE_APPLICATION_VIEWED_BY_IRENE = 'rental-manager-api/api/v1/users/capps/applicationViewedByIrene',
  UPDATE_ONBOARDING_PAGE_VIEWED = 'rental-manager-api/api/v1/users/capps/createCappsUser',
  VIEW_SHARED_DOCUMENT = 'rental-manager-api/api/v1/users/rad/viewSharedDocumentV2';

export const GET_TERM_SET = 'rental-manager-api/api/v1/users/capps/getTermSet';
export const RETRIEVE_SHARED_REPORTS = 'rental-manager-api/api/v1/users/screening/retrieveSharedReports';
export const GET_USER_APPLICATION_PERMISSION_STATUSES =
  'rental-manager-api/api/v1/users/userManagementApplicationPermission/getUserApplicationPermissionStatuses';
export const CREATE_APPLICATION_MANAGER =
  'rental-manager-api/api/v1/users/userManagementApplicationPermission/createApplicationManager';
export const REQUEST_APPLICATION_MANAGER_ID_VERIFICATION =
  'rental-manager-api/api/v1/users/capps/requestApplicationManagerIdVerification';
export const CREATE_PERMISSION_REQUEST =
  'rental-manager-api/api/v1/users/userManagementApplicationPermission/createPermissionRequest';
export const DECLINE_APPLICATION = 'rental-manager-api/api/v1/users/capps/declineApplication';
export const GET_DECLINE_REASONS = 'rental-manager-api/api/v1/users/capps/getDeclineReasons';
export const GET_PROPERTY_ANALYTICS = 'rental-manager-api/api/v1/users/properties/webAnalytics/get';
export const SET_NAME = 'rental-manager-api/api/v1/users/profile/setName';
export const GET_NAMES = 'rental-manager-api/api/v1/users/profile/getNames';
export const GET_ADDRESS_AUTOCOMPLETE = 'rental-manager-api/api/v1/properties/addresses/autocomplete';
export const GET_ADDRESS_DETAILS = 'rental-manager-api/api/v1/properties/addresses/details';
export const CREATE_PROPERTY = 'rental-manager-api/api/v1/users/properties/create';
export const GET_PROPERTIES = 'rental-manager-api/api/v1/users/properties/list';
export const GET_RENTAL_PROTECTION_LEGAL_DISCLAIMER_CONTENT =
  'rental-manager-api/api/v1/users/properties/rentGuarantee/getDisclaimers';
export const GET_LISTING_EXISTS_IN_LISTING_HUB = 'rental-manager-api/api/v1/properties/getListingExistsInListingHub';
export const GET_SPLIT_AB_TREATMENT = 'rental-manager-api/api/v1/users/experiments/getTreatment';
export const GET_SHARED_APPLICATION = 'rental-manager-api/api/v1/users/capps/getRentalApplicationShareForLandlord';
export const ACCEPT_APPLICATION_SHARE = 'rental-manager-api/api/v1/users/capps/acceptRentalApplicationShare';
export const DECLINE_APPLICATION_SHARE = 'rental-manager-api/api/v1/users/capps/declineRentalApplicationShare';

export {
  FETCH_APPLICANTS_DATA_ENDPOINT,
  FETCH_ID_VERIFICATION_STATUS_ENDPOINT,
  FETCH_LISTING_APPLICATIONS_ENDPOINT,
  FETCH_ONBOARDING_PAGE_VIEWED,
  GET_APPLICATIONS_BROWNOUT_WARNING_MESSAGE_ENDPOINT,
  GET_LEAD_DETAILS,
  MARK_RENTAL_TERMS_ACCEPTED_ENDPOINT,
  RETRIEVE_SHARED_DOCUMENTS,
  SEND_INVITATION,
  COPY_APPLICATION_LINK,
  SET_ENROLLMENT_STATUS,
  UPDATE_APPLICATION_VIEWED_BY_IRENE,
  UPDATE_ONBOARDING_PAGE_VIEWED,
  VIEW_SHARED_DOCUMENT,
};
